import { createConsumer } from "@anycable/web"

// ActionCable-compatible consumer (used by Turbo Streams custom element).
// URL is auto-detected from <meta name="action-cable-url"> or defaults to /cable.
// Extended protocol enables presence, session recovery, and whisper support.
export const consumer = createConsumer({ protocol: "actioncable-v1-ext-json" })

// Full AnyCable Cable instance for presence API (shares the same WebSocket connection).
export const cable = consumer.cable
